import React from "react";
import { Check } from "lucide-react";
import styles from "./KitOptionPicker.module.css";

export interface KitOption {
  id: string;
  name: string;
  image: string;
}

interface KitOptionPickerProps {
  kits: KitOption[];
  value: string;
  onChange: (id: string) => void;
  name?: string;
  hasError?: boolean;
}

export function KitOptionPicker({
  kits,
  value,
  onChange,
  name = "selectedKit",
  hasError,
}: KitOptionPickerProps) {
  return (
    <div
      className={`${styles.kitGrid} ${hasError ? styles.kitGridError : ""}`}
    >
      {kits.map((kit) => (
        <label key={kit.id} className={styles.kitCard}>
          <input
            type="radio"
            name={name}
            value={kit.id}
            checked={value === kit.id}
            onChange={() => onChange(kit.id)}
          />
          <span className={styles.kitImageWrap}>
            {kit.image ? (
              <img src={kit.image} alt={kit.name} />
            ) : (
              <span className={styles.kitImagePlaceholder} />
            )}
            <span className={styles.kitCheck}>
              <Check size={13} strokeWidth={3} />
            </span>
          </span>
          <span className={styles.kitName}>{kit.name}</span>
        </label>
      ))}
    </div>
  );
}
